import React from "react";
import { Tooltip } from "antd";
import { QuestionCircleOutlined } from "@ant-design/icons";

interface FormHelpTooltipProps {
  title: React.ReactNode;
  icon?: React.ReactNode;
  iconStyle?: React.CSSProperties;
}

const FormHelpTooltip: React.FC<FormHelpTooltipProps> = ({
  title,
  icon,
  iconStyle,
}) => {
  return (
    <Tooltip title={title}>
      {icon || (
        <QuestionCircleOutlined
          style={{
            marginLeft: 8,
            marginTop: 4,
            color: "var(--primary-color)",
            cursor: "pointer",
            ...iconStyle,
          }}
        />
      )}
    </Tooltip>
  );
};

export default FormHelpTooltip;
